var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "scrollableDiv",
      staticClass: "story-form-post-creator hide-scrollbar",
    },
    [
      !_vm.isSharedStory
        ? _c("section", { staticClass: "publish-date" }, [
            _c("label", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("dash.post-creator.form.publish-date")) +
                  " \n            "
              ),
              _vm.storySelected.planifiedDate.isEdited()
                ? _c(
                    "span",
                    {
                      staticClass: "restore",
                      on: { click: _vm.storySelected.planifiedDate.restore },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.cancel-changes")
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c(
              "div",
              { staticClass: "content-section" },
              [
                _c("SelectComponent", {
                  attrs: {
                    changeValueSelect: _vm.changeSelectPublishDate,
                    data: {
                      now: _vm.$t("dash.post-creator.form.now"),
                      flanified: _vm.$t("dash.button.schedule"),
                    },
                    valueSelect: !_vm.storySelected.planifiedDate.date
                      ? "now"
                      : "flanified",
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
                _vm.storySelected.planifiedDate.date
                  ? [
                      _c("div", { staticClass: "input-date" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.storySelected.planifiedDate.dayDynamicLabel
                            )
                          ),
                        ]),
                        _c("i", { staticClass: "fa-regular fa-calendar" }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.models.date,
                              expression: "models.date",
                            },
                          ],
                          attrs: {
                            type: "date",
                            disabled: !_vm.storySelected.planifiedDate.date,
                            min: new Date()
                              .toLocaleString("fr-FR")
                              .split(" ")[0]
                              .split("/")
                              .reverse()
                              .join("-"),
                          },
                          domProps: { value: _vm.models.date },
                          on: {
                            click: (e) => e.target.showPicker(),
                            change: _vm.setDate,
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.models, "date", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "input-hours" },
                        [
                          _c("VueTimepicker", {
                            attrs: { "manual-input": "" },
                            on: { close: _vm.setDate },
                            model: {
                              value: _vm.models.hours,
                              callback: function ($$v) {
                                _vm.$set(_vm.models, "hours", $$v)
                              },
                              expression: "models.hours",
                            },
                          }),
                          _c("i", { staticClass: "fa-regular fa-clock" }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _c("section", { staticClass: "content-media" }, [
        _c("label", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("dash.post-creator.story.background")) +
              " \n            "
          ),
          _vm.storySelected.background.isEdited()
            ? _c(
                "span",
                {
                  staticClass: "restore",
                  on: { click: _vm.storySelected.background.restore },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("dash.post-creator.form.cancel-changes")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "container-medias" },
          [
            _c(
              "div",
              {
                staticClass: "btn-color",
                style: { background: _vm.storySelected.background.color },
                on: {
                  click: () => {
                    _vm.colorPickerShow = true
                    _vm.showPipette = true
                  },
                },
              },
              [
                _vm.colorPickerShow
                  ? _c(
                      "div",
                      {
                        staticClass: "picker-color",
                        on: {
                          mouseleave: () => {
                            _vm.colorPickerShow = false
                          },
                          mousedown: function ($event) {
                            _vm.showPipette = false
                          },
                        },
                      },
                      [
                        _vm.eyeDropperIsAccess && _vm.showPipette
                          ? _c("div", {
                              staticClass: "icon-pipette",
                              on: {
                                mousedown: function ($event) {
                                  $event.stopPropagation()
                                },
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.startEyeDropper.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _c("chrome-picker", {
                          attrs: {
                            value: { hex: _vm.storySelected.background.color },
                          },
                          on: { input: _vm.updateFromPicker },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            !_vm.isSharedStory
              ? [
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "",
                        expression: "''",
                      },
                    ],
                    ref: "inputMediaStory",
                    attrs: {
                      name: "file",
                      type: "file",
                      id: "file",
                      multiple: false,
                      accept:
                        ".jpg, .jpeg, .png, .webp, .mp4, .gif, .webm, .ogg, .avi, .wmv, .flv, .mkv, .mov",
                      hidden: "",
                    },
                    on: { change: _vm.uploadBackgroundFile, click: () => {} },
                  }),
                  _c("DropFile", {
                    attrs: { targetInput: _vm.$refs.inputMediaStory },
                  }),
                  _vm.storySelected.background.file
                    ? [
                        _vm.storySelected.background.file.info.type2 == "image"
                          ? _c(
                              "div",
                              {
                                staticClass: "media-container picture",
                                on: { click: _vm.openBackgroundResizeMode },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-circle-xmark",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeBackgroundFile.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "media picture" }, [
                                  _c("img", {
                                    staticClass: "source",
                                    attrs: {
                                      draggable: "false",
                                      src: _vm.storySelected.background.file
                                        .url,
                                      alt: "",
                                    },
                                  }),
                                ]),
                              ]
                            )
                          : _vm.storySelected.background.file.info.type2 ==
                            "video"
                          ? _c(
                              "div",
                              {
                                staticClass: "media-container video",
                                on: { click: _vm.openBackgroundResizeMode },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-circle-xmark",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeBackgroundFile.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                                _c("div", { staticClass: "media video" }, [
                                  _c("video", {
                                    staticClass: "source",
                                    attrs: {
                                      muted: "",
                                      loop: "",
                                      playsinline: "",
                                      preload: "metadata",
                                      onloadedmetadata: "this.muted = true",
                                      src: _vm.storySelected.background.file
                                        .url,
                                      type: _vm.storySelected.background.file
                                        .info.type,
                                    },
                                    domProps: { muted: true },
                                  }),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _c(
                        "div",
                        {
                          staticClass: "btn-add-media",
                          on: { click: _vm.clickBtnAddMedia },
                        },
                        [_c("i", { staticClass: "fa-solid fa-photo-film" })]
                      ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("section", { staticClass: "content-stickers" }, [
        _c("label", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("dash.post-creator.story.stickers")) +
              " \n            "
          ),
          _vm.storySelected.stickers.isEdited()
            ? _c(
                "span",
                {
                  staticClass: "restore",
                  on: { click: _vm.storySelected.stickers.restore },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("dash.post-creator.form.cancel-changes")) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "container-stickers" },
          [
            _c(
              "draggable",
              _vm._b(
                {
                  ref: "listStickers",
                  staticClass: "list-stickers hide-scrollbar",
                  attrs: { filter: ".lockdrag" },
                  on: {
                    start: function ($event) {
                      _vm.drag = true
                    },
                    end: _vm.onDragStickerEnd,
                  },
                  model: {
                    value: _vm.storySelected.stickers.items,
                    callback: function ($$v) {
                      _vm.$set(_vm.storySelected.stickers, "items", $$v)
                    },
                    expression: "storySelected.stickers.items",
                  },
                },
                "draggable",
                _vm.dragOptions,
                false
              ),
              [
                _c(
                  "transition-group",
                  {
                    attrs: {
                      type: "transition",
                      name: !_vm.drag ? "flip-list" : null,
                    },
                  },
                  [
                    _vm._l(
                      _vm.storySelected.stickers.items,
                      function (sticker, index) {
                        return [
                          false && sticker.id == "btnAdd"
                            ? _c(
                                "div",
                                {
                                  key: "btnAdd",
                                  staticClass: "btn-add-sticker lockdrag",
                                  class: { "no-drag": _vm.drag },
                                  on: { click: _vm.openMenuStickers },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "auto",
                                        height: "auto",
                                        viewBox: "0 0 44 44",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          "clip-rule": "evenodd",
                                          d: "M12.6667 0H31.3333C38.3289 0 44 5.67106 44 12.6667V25.1242C44 26.5387 43.4381 27.8952 42.4379 28.8954L28.8954 42.4379C27.8952 43.4381 26.5387 44 25.1242 44H12.6667C5.67106 44 0 38.3289 0 31.3333V12.6667C0 5.67106 5.67106 0 12.6667 0ZM12.6667 4C7.8802 4 4 7.8802 4 12.6667V31.3333C4 36.1198 7.8802 40 12.6667 40H25.3333L40 25.3333V12.6667C40 7.8802 36.1198 4 31.3333 4H12.6667Z",
                                          fill: "#F1EDF5",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M35.334 23.334H43.334L41.334 27.334H35.334C30.9157 27.334 27.334 30.9157 27.334 35.334V40.6673L23.334 41.334V35.334C23.334 28.7066 28.7066 23.334 35.334 23.334Z",
                                          fill: "#F1EDF5",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M16.6673 18.0007C16.6673 19.4734 15.4734 20.6673 14.0007 20.6673C12.5279 20.6673 11.334 19.4734 11.334 18.0007C11.334 16.5279 12.5279 15.334 14.0007 15.334C15.4734 15.334 16.6673 16.5279 16.6673 18.0007Z",
                                          fill: "#F1EDF5",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M32.6673 18.0007C32.6673 19.4734 31.4734 20.6673 30.0007 20.6673C28.5279 20.6673 27.334 19.4734 27.334 18.0007C27.334 16.5279 28.5279 15.334 30.0007 15.334C31.4734 15.334 32.6673 16.5279 32.6673 18.0007Z",
                                          fill: "#F1EDF5",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          "clip-rule": "evenodd",
                                          d: "M12.9633 26.2096C13.7676 25.4526 15.0334 25.4909 15.7904 26.2953C17.9806 28.6224 20.4661 29.1591 22.4662 29.1247C23.4806 29.1072 24.3615 28.9402 24.986 28.7775C25.2962 28.6967 25.5372 28.6185 25.6927 28.5638C25.7703 28.5365 25.8261 28.5152 25.8581 28.5027C25.874 28.4965 25.884 28.4924 25.8876 28.4909L25.8852 28.492L25.8826 28.4931M25.8881 28.4907C26.9014 28.062 28.0717 28.5325 28.5056 29.5448C28.9407 30.5601 28.4704 31.7359 27.4552 32.171L26.675 30.3507C27.4552 32.171 27.4543 32.1714 27.4534 32.1718L27.4514 32.1726L27.4469 32.1745L27.4361 32.1791L27.4065 32.1913C27.3834 32.2008 27.3534 32.2129 27.3168 32.2273C27.2435 32.2559 27.1437 32.2936 27.0195 32.3373C26.7715 32.4245 26.4239 32.5364 25.9945 32.6483C25.1398 32.871 23.9374 33.0999 22.5351 33.1241C19.7019 33.1729 16.0207 32.3763 12.8776 29.0368C12.1206 28.2324 12.1589 26.9667 12.9633 26.2096M25.8881 28.4907C25.888 28.4908 25.8878 28.4909 25.8876 28.4909L25.8884 28.4906L25.8892 28.4903C25.889 28.4904 25.8887 28.4905 25.8881 28.4907Z",
                                          fill: "#F1EDF5",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "stricker",
                                  class: {
                                    lockdrag: ["music", "post"].includes(
                                      sticker.type
                                    ),
                                    "no-drag":
                                      _vm.drag && sticker.type == "post",
                                  },
                                  on: { click: () => _vm.clickSticker(index) },
                                },
                                [
                                  sticker.type !== "post"
                                    ? _c("i", {
                                        staticClass: "fa-solid fa-circle-xmark",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return sticker.delete.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "sticker-view" },
                                    [
                                      sticker.type == "music"
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text:
                                                  sticker.data.music &&
                                                  (sticker.data.music.track
                                                    ? sticker.data.music.track
                                                        .title
                                                    : sticker.data.music
                                                        .original_sound.title),
                                                position: "bottom",
                                                classCustom: "music",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "disk" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: sticker.data.music
                                                        .track
                                                        ? sticker.data.music
                                                            .track
                                                            .cover_artwork_thumbnail_uri
                                                        : sticker.data
                                                            .original_sound
                                                            .ig_artist
                                                            .profile_pic_url,
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c("stickerWrapper", {
                                            attrs: {
                                              stickerInstance: sticker,
                                              story: _vm.storySelected,
                                              sticker: { ...sticker },
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _c("p", { staticClass: "sticker-type" }, [
                                    _vm._v(_vm._s(sticker.type)),
                                  ]),
                                ]
                              ),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      !_vm.isSharedStory
        ? _c("section", { staticClass: "content-facebook" }, [
            _c("label", [_vm._v("Facebook")]),
            _c(
              "div",
              { staticClass: "type-switch" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("dash.post-creator.story.share-on-facebook")
                    ) +
                    "\n\n            "
                ),
                _c("ComponentSwitch", {
                  attrs: {
                    value: _vm.storySelected.shareInFacebook,
                    onChange: _vm.handlerSharePostInStoryFacebook,
                    id: "switch-share-story",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }